// extracted by mini-css-extract-plugin
export default {"research":"research_research__-8Cq5","imgResearche":"research_imgResearche__GuIwR","topBottom":"research_topBottom__4Gmyl"};